// import { Link } from "react-router-dom";
// import cx from "classnames";
// import parse from "html-react-parser";

// CSS
import styles from "./footer.module.scss";

const Footer = (props) => {
    //const { footerConferences,
    //        goToConferences,
    //        footer_message
    //      } = props;

    const {
            goToConferences
          } = props;

    return (
        <div className={styles.footer}>
            <div className={styles.primary}>
                <div className={styles.column}>
                    <span className={styles.header}>THE COMPANY</span>
                    <a
                        className={styles.link}
                        href="https://symphony.com/company/about/"
                        rel="nofollow noreferrer"
                        target="_blank"
                    >
                        About Symphony
                    </a>
                    <a
                        className={styles.link}
                        href="https://symphony.com/company/partners/"
                        rel="nofollow noreferrer"
                        target="_blank"
                    >
                        Partnerships
                    </a>
                    <a
                        className={styles.link}
                        href="https://symphony.com/company/news-press-events/"
                        rel="nofollow noreferrer"
                        target="_blank"
                    >
                        News
                    </a>
                    <a
                        className={styles.link}
                        href="https://symphony.com/insights/blog/"
                        rel="nofollow noreferrer"
                        target="_blank"
                    >
                        Blog
                    </a>
                </div>
                <div className={styles.column}>
                    <span className={styles.header}>CONFERENCES</span>

                    {/*
                    <Link
                        className={styles.link}
                        to={{
                            pathname: "/conferences/nyc-2024",
                            state: {
                                conference: footerConferences["nyc-2024"],
                            },
                        }}
                    >
                        Symphony Innovate New York 2024
                    </Link>
                    */}

                    <span className={styles.link} onClick={goToConferences}>
                        View past events
                    </span>
                </div>
            </div>
            <div className={styles.secondary}>
                <div className={styles.row}>
                    <span>
                        &copy; {new Date().getFullYear()} Symphony Communication
                        Services LLC. All rights reserved.
                    </span>
                    <a
                        className={styles.link}
                        href="https://symphony.com/privacy-policy/"
                        rel="nofollow noreferrer"
                        target="_blank"
                    >
                        Terms & Conditions
                    </a>
                </div>
                <div className={styles.row}>
                    <p className={styles.gdpr}>
                        By attending Symphony Innovate London 2025, you consent to (i) be photographed, filmed and/or otherwise recorded; (ii) the recording of your questions and comments posted during the live sessions; (iii) be included in Symphony’s newsletter distribution list (which distribution will contain an unsubscribe option if you no longer desire to receive the newsletters); and (iv) the use and publication by Symphony Communication Services, LLC, its affiliates and any applicable media agency acting on Symphony’s behalf of (1) your name, likeness, statements & voice (if applicable), (2) a live stream of Symphony Innovate London 2025 and portions thereof, and (3) images, descriptions (whether verbal or written) and videos of any developments you bring to, or display or created for purposes of participating in the event, in each case as such information or media is received or recorded by Symphony at Symphony Innovate London 2025, for any purpose in which Symphony engages, including any promotion, advertisement or other conduct of trade.
                        {/*
                          <div className={styles.footer_message}>
                          { footer_message }

                        </div>
                        */}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Footer;
